module.exports = __webpack_public_path__ + "img/CSAT_ENG2.b51df438.png";